module.exports = __webpack_public_path__ + "img/冥王.4ee09d17.svg";